
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { TrendingUp, Search, Globe, ChevronDown, Layout, List } from 'lucide-react';

interface TopicHeaderProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  selectedRegion: string;
  selectedView: "visual" | "list";
  setSelectedView: (view: "visual" | "list") => void;
}

const TopicHeader: React.FC<TopicHeaderProps> = ({
  searchQuery,
  setSearchQuery,
  selectedRegion,
  selectedView,
  setSelectedView
}) => {
  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8">
      <div>
        <h1 className="text-3xl font-bold text-directpress-blue dark:text-white flex items-center">
          <TrendingUp className="mr-2 h-8 w-8" /> 
          Trending Topics
        </h1>
        <p className="text-muted-foreground">Discover what's capturing attention right now</p>
      </div>
      
      <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
        <div className="relative w-full md:w-64">
          <Search className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
          <Input 
            placeholder="Search topics..." 
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="pl-9"
          />
        </div>
        
        <div className="flex gap-2">
          <Button variant="outline" className="gap-1">
            <Globe className="h-4 w-4" />
            <span className="hidden sm:inline">{selectedRegion}</span>
            <ChevronDown className="h-4 w-4" />
          </Button>
          
          <Button 
            variant={selectedView === "visual" ? "default" : "outline"} 
            size="icon"
            onClick={() => setSelectedView("visual")}
          >
            <Layout className="h-4 w-4" />
          </Button>
          
          <Button 
            variant={selectedView === "list" ? "default" : "outline"} 
            size="icon"
            onClick={() => setSelectedView("list")}
          >
            <List className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TopicHeader;
